import Budget from "./Budget";

export default Budget;